<template>
<a href="https://morikoh.co.jp/" target="_blank" class="morikoh-badge-pc" rel="noopener">
  <div class="m-content">
    <div class="m-icon">
      <img src="https://reiwasteel.co.jp/wp/wp-content/uploads/2026/02/green.png" alt="森鋼" loading="lazy" decoding="async">
    </div>
    <div class="m-text">
      <span class="m-label">Group Company</span>
      <span class="m-title">株式会社 森 鋼</span>
    </div>
  </div>
  <div class="glass-content">
    <div class="glass-icon-sp">
      <img src="https://reiwasteel.co.jp/wp/wp-content/uploads/2026/top-webp/morikohcoltd-1.webp" alt="森鋼ロゴ" width="160" height="40" loading="lazy" decoding="async" style="height: auto;">
    </div>
    <div class="glass-text-block">
        <span class="glass-text">
            <span class="brand-navy">株式会社 森 鋼</span><br>
            <span class="brand-lime">公式サイトはこちら</span>
        </span>
        <span class="glass-arrow">↗</span>
    </div>
  </div>
</a>
</template>

<style lang="scss" scoped>
a{
  display: flex;
  position: fixed;
  bottom: 2rem;          /* 30px */
  right: 2rem;           /* 30px */
  z-index: 9999;
  background: rgba(255, 255, 255, .1);
  backdrop-filter: blur(.6rem);          /* 10px */
  -webkit-backdrop-filter: blur(.6rem);  /* 10px */
  border: 1px solid rgba(255, 255, 255, .3); /* 1px */
  padding: .4rem .9rem .4rem .5rem;  /* 6px 14px 6px 8px */
  border-radius: 3.3rem;                  /* 50px */
  text-decoration: none;
  align-items: center;
  gap: .5rem;                            /* 8px */
  box-shadow: 0 .6rem 2rem rgba(0,0,0,.3); /* 10px 30px */
  transform: scale(.8);
  transform-origin: right bottom;
  transition: transform .3s ease;
  @media screen and (max-width: module.$tab){
    position: relative;
    right: auto;
    bottom: auto;
    z-index: 2;
    transform: scale(1);
    width: 90%;
    margin: 3.2rem auto 0;
    padding: 2.4rem;
    background: rgba(#FFF,.2);
    backdrop-filter: blur(1rem);
    -webkit-backdrop-filter: blur(1rem);
    border: 1px solid rgba(#FFF, .2);
    box-shadow: 0 0 2rem rgba(180, 243, 35, .4);
    transform-origin: center;
  }
  @media screen and (max-width: module.$phone){
    border-radius: 1rem;
    padding: 1.44rem 1.6rem;
    transform: scale(.9);
  }
  &:hover{
    transform: scale(0.85);
    @media screen and (max-width: module.$tab){
      transform: scale(1.02);
    }
  }
  .m-content{
    @include module.flex();
    align-items: center;
    justify-content: center;
    gap: .5rem;
    @media screen and (max-width: module.$tab){
      display: none;
    }
  }
  .m-icon{
    width: 2.1rem;     /* 32px */
    height: 2.1rem;    /* 32px */
    flex-shrink: 0;
    img{
      border-radius: 50%;
    }
  }
  .m-text{
    display: flex;
    flex-direction: column;
    line-height: 1.1;
  }
  .m-label {
    color: module.$lime;
    font-size: .6rem;   /* 9px */
    font-weight: 700;
    letter-spacing: .003rem; /* .05em ≒ .75px */
  }
  .m-title {
    color: #fff;
    font-size: .8rem;   /* 12px */
    font-weight: 700;
    white-space: nowrap;
  }
  .glass-content{
    display: none;
    @media screen and (max-width: module.$tab){
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 1.2rem;
      .glass-icon-sp{
        width: 10.66rem;
        height: auto;
        img{
          width: 100%;
          height: auto;
          filter: drop-shadow(0 0 0.53rem rgba(180, 243, 35, 0.5));
        }
      }
      .glass-text-block{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        .glass-text{
          .brand-navy{
            color: #fff;
            font-size: 1.73rem;
            letter-spacing: 0.05em;
          }
          .brand-lime{
            color: #b4f323;
            font-size: 1rem;
            font-weight: 700;
          }
        }
        .glass-arrow{
          font-size: 2.13rem;
          color: #b4f323;
        }
      }
    }
  }
}
</style>

<script>
export default {
}
</script>